import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      dark: {},
      light: {
        white: '#ffffff',
        authAppbar: '#043047',
        appbar: '#ffffff',
        appbarTitleActive: '#56afdf',
        navigation: '#043047',
        primary: '#217fb0',
        textSecondary: '#848fa0',
        textPrimary: '#353e4d',
        link: '#116795',
        background: '#f8fafc',
        inputBorder: '#d7dee7',
        good: '#41cf5f',
        alert: '#f04526',
        working: '#0DC715',
        disabled: '#e7ecf2',
        info: '#dff1fa',
        loadingBar: '#217fb0',
        menuButton: '#043047',
        buttonRipple: '#217fb0',
        dataTableExpandRow: '#f7fafc',
        deleteBtn: '#d73016',
        added: '#7bc9f3',
        removed: '#fa9a88',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
